const runtime = typeof document === 'object';
const plan = () => new Promise(resolve => {
  const delay = 1000;
  setTimeout(() => {
    const ga = (runtime && document.cookie.match('(^|;) ?_ga=([^;]*)(;|$)') || [])[2];
    const PUB_ID = (runtime && document.cookie.match('(^|;) ?_PUB_ID=([^;]*)(;|$)') || [])[2];
    const status = PUB_ID && {
      LoggedIn: PUB_ID
    } || {
      Anonymous: ga || 'private'
    };
    resolve({
      type: status && status.Anonymous && 'not-logged-in' || 'free',
      status
    });
  }, delay);
});
module.exports = plan;